import React from 'react';

import type { TypographyProps } from './types';
import { StyledParagraph } from './StyledComponents';

export const Paragraph = ({
  children,
  isTermsContent,
  testID,
  ...rest
}: TypographyProps): React.ReactElement => (
  <StyledParagraph
    data-testid={testID}
    isTermsContent={isTermsContent}
    {...rest}
  >
    {children}
  </StyledParagraph>
);
